import React from 'react';

const SpreedlyCheckoutSdkFormContext = React.createContext();

export const { Provider, Consumer } = SpreedlyCheckoutSdkFormContext;
export default SpreedlyCheckoutSdkFormContext;
